import React, { Suspense, lazy, useCallback, useRef, useState } from 'react';
import { useTranslation } from '../context/TranslationContext';
import { T } from './Typo';

const PaperCanvas = lazy(() => import('./PaperCanvas'));

/* 2 personas × 6 h a la semana × 46 semanas: las horas que la escena «ordena» */
const HOURS = 552;
const INTRO_MS = 5200;

const COPY = {
  es: {
    h1a: 'Pasamos a limpio',
    h1b: 'tu empresa.',
    lead: 'De la web de cinco páginas a la aplicación que sustituye al Excel de toda la oficina. Precio cerrado y por escrito antes de empezar.',
    cta: 'Pedir presupuesto',
    counter: 'horas al año de trabajo a mano',
    cue: 'Baja y se ordena',
  },
  en: {
    h1a: 'We make a clean copy',
    h1b: 'of your company.',
    lead: 'From a five-page website to the app that replaces the spreadsheet the whole office shares. A fixed, written price before we start.',
    cta: 'Get a quote',
    counter: 'hours a year of manual work',
    cue: 'Scroll and it sorts itself out',
  },
};

const reduced = typeof window !== 'undefined'
  && window.matchMedia
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export default function Hero() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;
  const track = useRef(null);
  const start = useRef(null);
  const [hours, setHours] = useState(HOURS);

  // Progreso 0…1: una intro automática lleva la escena a la mitad
  // y el scroll dentro del hero la termina. Con movimiento reducido no hay
  // intro: la escena empieza a medio ordenar y solo avanza con el scroll.
  const getProgress = useCallback((now) => {
    let intro = 0.3;
    if (!reduced) {
      if (start.current === null) start.current = now;
      const x = Math.min(1, (now - start.current) / INTRO_MS);
      intro = (1 - Math.pow(1 - x, 3)) * 0.58;
    }
    const el = track.current;
    let sc = 0;
    if (el) {
      const r = el.getBoundingClientRect();
      const range = r.height - window.innerHeight;
      sc = range > 0 ? Math.min(1, Math.max(0, -r.top / (range * 0.8))) : 0;
    }
    return intro + sc * (1 - intro);
  }, []);

  const onDone = useCallback((f) => setHours(Math.round(HOURS * (1 - f))), []);

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-track" ref={track}>
        <div className="hero-sticky">
          <Suspense fallback={null}>
            <PaperCanvas getProgress={getProgress} onDone={onDone} calm={reduced} />
          </Suspense>
          <div className="wrap hero-ui">
            <div className="hero-copy">
              <h1 id="hero-title" className="t-hero">
                {c.h1a} <span className="blue">{c.h1b}</span>
              </h1>
              <p className="t-lead"><T>{c.lead}</T></p>
              <div className="hero-row">
                <a className="btn" href="#contacto">{c.cta}</a>
                <p className="counter" aria-hidden="true">
                  <s>552</s>
                  <b>{hours}</b>
                  <span>{c.counter}</span>
                </p>
              </div>
            </div>
          </div>
          <p className="scroll-cue" aria-hidden="true" style={{ opacity: hours === 0 ? 0 : 1 }}>{c.cue}</p>
        </div>
      </div>
    </section>
  );
}
